import Card from './components/Card';
import CardBody from './components/CardBody';
import CardDivider from './components/CardDivider';
import CardTitle from './components/CardTitle';
export { CardBody, CardDivider, CardTitle };
export default Card;